export default __webpack_public_path__ + "static/media/element_59.48f3e7f3.jpg";